import ButtonsBlock from './ButtonsBlock/ButtonsBlock'
import ModalZD from './ModalZD/ModalZD'

export { ButtonsBlock, ModalZD }
